import produce from 'immer';
import {
  CHANGE_MENU_ITEMS_ACTIONTYPE,
  CHECK_ONBOARD_DEVICE_VALID_ACTIONTYPE,
  GET_ROLES_ACTIONTYPE,
  IS_LOGGED_SUCCESS_ACTIONTYPE,
  PUBLISH_ERROR_ACTIONTYPE,
  RESET_APP_DATA_ACTIONTYPE, SET_NOTIF_SOUND_SETTING_ACTIONTYPE,
  SET_ONBOARD_DEVICE_ID_ACTIONTYPE,
  SET_ONBOARD_SUPERVISOR_ID_ACTIONTYPE,
  SET_USER_ACTIONTYPE,
  SHOW_CIRCULAR_LOADER_ACTIONTYPE, UPDATE_LOGGED_USER_ACTIONTYPE,
  VALIDATE_TOKEN_ACTIONTYPE,
} from './actionTypes';
import { FAILURE_ACTION_TYPE_SUFFIX, REQUEST_ACTION_TYPE_SUFFIX, SUCCESS_ACTION_TYPE_SUFFIX } from '../store/constants';
import { GUEST_SIDE_MENU_OPTIONS } from '../utils/NavBar.options';
import USER_ROLES from '../utils/UserRoles';
import { getNotificationSoundSetting, setNotifSoundSetting } from '../services/settings.service';

export const initialState = {
  user: {},
  isLoggedIn: false,
  token: '',
  tokenLoader: false,
  menuItems: GUEST_SIDE_MENU_OPTIONS,
  showLinearLoader: false,
  showCircularLoader: false,
  errorObj: {},
  settings: {
    notificationSound: getNotificationSoundSetting(),
  },
  roles: {
    0: USER_ROLES.ADMIN,
    1: USER_ROLES.MANAGER,
    2: USER_ROLES.SUPERVISOR,
    3: USER_ROLES.OWNER,
    4: USER_ROLES.RELATIVE,
    5: USER_ROLES.USER,
    6: USER_ROLES.MONITOR,
    7: USER_ROLES.BRANCH_MONITOR,
    8: USER_ROLES.COMPANY_MONITOR
  },
  deviceOnboard: {
    deviceId: "",
    supervisorId: "",
    validDeviceResponse: {}
  }
};

const globalReducer = produce((draft, action) => {
  const actionType = action.type || '';
  if (actionType.endsWith(REQUEST_ACTION_TYPE_SUFFIX)) {
    draft.showLinearLoader = true;
  } else if (actionType.endsWith(SUCCESS_ACTION_TYPE_SUFFIX) || actionType.endsWith(FAILURE_ACTION_TYPE_SUFFIX)) {
    draft.showLinearLoader = false;
  }
  switch (actionType) {
    case IS_LOGGED_SUCCESS_ACTIONTYPE.COMPLETED: {
      draft.isLoggedIn = true;
      break;
    }
    case SET_USER_ACTIONTYPE.COMPLETED: {
      const { user, token } = action.payload;
      draft.user = user;
      draft.token = token;
      break;
    }
    case UPDATE_LOGGED_USER_ACTIONTYPE.COMPLETED: {
      draft.user = action.payload;
      break;
    }
    case VALIDATE_TOKEN_ACTIONTYPE.LOADING: {
      draft.tokenLoader = action.payload;
      break;
    }
    case RESET_APP_DATA_ACTIONTYPE.TRIGGER: {
      return initialState;
    }
    case SHOW_CIRCULAR_LOADER_ACTIONTYPE.TRIGGER: {
      draft.showCircularLoader = true;
      break;
    }
    case SHOW_CIRCULAR_LOADER_ACTIONTYPE.COMPLETED: {
      draft.showCircularLoader = false;
      break;
    }
    case CHANGE_MENU_ITEMS_ACTIONTYPE.COMPLETED: {
      draft.menuItems = action.payload;
      break;
    }
    case PUBLISH_ERROR_ACTIONTYPE.TRIGGER: {
      const errorObj = action.payload;
      errorObj.key = errorObj.key || Date.now;
      draft.errorObj = errorObj;
      break;
    }
    case GET_ROLES_ACTIONTYPE.SUCCESS: {
      draft.roles = action.payload;
      break;
    }
    case SET_NOTIF_SOUND_SETTING_ACTIONTYPE.COMPLETED: {
      setNotifSoundSetting(action.payload);
      draft.settings.notificationSound = action.payload;
      break;
    }
    case CHECK_ONBOARD_DEVICE_VALID_ACTIONTYPE.SUCCESS: {
      draft.deviceOnboard.validDeviceResponse = action.payload;
      break
    }
    case SET_ONBOARD_DEVICE_ID_ACTIONTYPE.COMPLETED: {
      draft.deviceOnboard.deviceId = action.payload
    }
    case SET_ONBOARD_SUPERVISOR_ID_ACTIONTYPE.COMPLETED: {
      draft.deviceOnboard.supervisorId = action.payload
    }
    default: {
      return draft;
    }
  }
}, initialState);

export default globalReducer;
